import {
  GET_BUSINESS_PAGE,
  SET_BUSINESS_PAGE,
  CHANGE_MODAL_EMAIL,
  CHANGE_MODAL_MESSAGE,
  CHANGE_MODAL_NAME,
  SEND_MODAL_FORM,
  SEND_MODAL_FORM_RESPONSE,
  BUSINESS_PAGE_RESET,
} from "../constants/ActionTypes";

export const getBusinessPage = id => ({
  type: GET_BUSINESS_PAGE,
  id,
});

export const setBusinessPage = payload => ({
  type: SET_BUSINESS_PAGE,
  payload,
});

export const changeName = payload => ({
  type: CHANGE_MODAL_NAME,
  payload,
});

export const changeEmail = payload => ({
  type: CHANGE_MODAL_EMAIL,
  payload,
});

export const changeMessage = payload => ({
  type: CHANGE_MODAL_MESSAGE,
  payload,
});

export const sendForm = payload => ({
  type: SEND_MODAL_FORM,
  payload,
});

export const sendFormResponse = payload => ({
  type: SEND_MODAL_FORM_RESPONSE,
  payload,
});

export const businessPageReset = payload => ({
  type: BUSINESS_PAGE_RESET,
  payload,
});



// WEBPACK FOOTER //
// ./actions/Business.js